/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//コンパクトブログ、アコーディオン
$('.c-accordion .c-open').each(function() {
  var $question = $(this);
  $question.on('click', function() {
    $(this).next('.panel').slideToggle();
    $(this).toggleClass('c-active');
  });
});

window.onload = function() {
    var elements = document.getElementsByClassName('d-1');
    
    Array.from(elements).forEach(function(element) {
        if (element.offsetHeight > 368) {
            element.style.maxHeight = "369px";
            element.style.overscrollBehaviorY = "contain";
            element.style.overflowY = "scroll";
        }
    });
}